import React from "react";
import { Dialog, DialogContent, Box, IconButton, useMediaQuery, useTheme } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";


const ReusablePopup = ({
  open,
  onClose,
  title,
  children,
  maxWidth = "sm",
  fullWidth = true,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth={maxWidth}
      fullWidth={fullWidth}
      PaperProps={{
        sx: {
          width: isMobile ? '95%' : undefined,
          margin: isMobile ? '10px' : undefined,
          maxHeight: isMobile ? '90vh' : undefined,
          borderRadius: isMobile ? '12px' : undefined
        }
      }}
    >
      <DialogContent sx={{ p: isMobile ? 1 : 2 }}>
        <Box sx={{ p: isMobile ? 1 : 2 }}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              borderBottom: "1px solid #e0e0e0",
              pb: 2,
              mb: 2,
            }}
          >
            <h2 style={{ margin: 0, fontSize: isMobile ? '1.2rem' : '1.5rem' }}>{title}</h2>
            <IconButton onClick={onClose} size="small">
              <CloseIcon />
            </IconButton>
          </Box>
          {children}
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default ReusablePopup;